import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import MDUserProfileHeader from './MDUserProfileHeader';
import "../Styles/UserManagement.css";
import { useParams } from 'react-router-dom';

const MDLogs = () => {
    const [logs, setLogs] = useState([]);
    const { mdId } = useParams();
    const siId = localStorage.getItem("siId"); // set once during login / selection

    const fetchLogs = () => {
        Axios.post(`/get_customer_logs`, {mdId, siId})
            .then((response) => {
                if (response.data.success) {
                    setLogs(response.data.logs || []);
                } else {
                    toast.error("Failed to get logs.", { position: "top-right" });
                }
            })
            .catch(() => {
                toast.error("Error fetching logs.", { position: "top-right" });
            });
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (
        <div className="dashboard">
            <MDUserProfileHeader isAdmin={true} />
            <div className="all-users-card">
                <h1 className="Title-alluser">Logs</h1>
                <div className="button-row">
                    <button onClick={fetchLogs} className="refresh-button">Refresh</button>
                </div>

                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th style={{ width: "5%" }}>#</th>
                                <th style={{ width: "15%" }}>Operator Email</th>
                                <th style={{ width: "10%" }}>First Name</th>
                                <th style={{ width: "10%" }}>Last Name</th>
                                <th style={{ width: "47%" }}>Message</th>
                                <th style={{ width: "13%" }}>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(logs || []).map((log, index) => (
                                <tr key={log.id}>
                                    <td>{index + 1}</td>
                                    <td>{log.operator_email}</td>
                                    <td>{log.first_name}</td>
                                    <td>{log.last_name}</td>
                                    <td>{log.log_message}</td>
                                    <td>{new Date(log.operation_time).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default MDLogs;
